/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, OpenAPISpec, OpenAPISpecSlug, OpenAPISpecSource, OpenAPISpecVisibility } from "./data-contracts";

/**
 * No description
 * @tags openapi
 * @name ListOpenApiSpecs
 * @summary List all OpenAPI spec
 * @request GET:/orgs/{organizationId}/openapi
 * @secure
 */

// @ts-ignore
export const listOpenAPISpecs: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OpenAPISpec[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/openapi",
  method: "get",
  streaming: false,
  tags: ["openapi"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name CreateOpenApiSpec
 * @summary Create an OpenAPI spec
 * @request POST:/orgs/{organizationId}/openapi
 * @secure
 */

// @ts-ignore
export const createOpenAPISpec: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Slug used as reference */
    slug: OpenAPISpecSlug;
    /** Create a specification from an URL */
    source: OpenAPISpecSource;
  };
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 201 | 400;
} = {
  route: "/orgs/{organizationId}/openapi",
  method: "post",
  streaming: false,
  tags: ["openapi"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name GetOpenApiSpecBySlug
 * @summary Get an OpenAPI spec by its slug
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const getOpenAPISpecBySlug: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "get",
  streaming: false,
  tags: ["openapi"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name CreateOrUpdateOpenApiSpecBySlug
 * @summary Create or update an OpenAPI spec
 * @request PUT:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const createOrUpdateOpenAPISpecBySlug: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Create a specification from an URL */
    source: OpenAPISpecSource;
  };
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 200 | 201 | 400;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "put",
  streaming: false,
  tags: ["openapi"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name UpdateOpenApiSpecBySlug
 * @summary Update OpenAPI spec visibility
 * @request PATCH:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const updateOpenAPISpecBySlug: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * The visibility setting of the OpenAPI spec.
     * * `private`: The spec is not publicly available.
     * * `public`: The spec is available to anyone with a public link.
     */
    visibility: OpenAPISpecVisibility;
  };
  RequestHeaders: {};
  ResponseBody: OpenAPISpec;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "patch",
  streaming: false,
  tags: ["openapi"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi
 * @name DeleteOpenApiSpecBySlug
 * @summary Delete an OpenAPI spec
 * @request DELETE:/orgs/{organizationId}/openapi/{specSlug}
 * @secure
 */

// @ts-ignore
export const deleteOpenAPISpecBySlug: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}",
  method: "delete",
  streaming: false,
  tags: ["openapi"],
  criticalityLevel: "low",
  deprecated: false,
};
